<div class="header" style="margin:0px">
  <div class="nav-container">

    <div class="title">
      <img class="company-logo"
           src="assets/logo.png"
           alt="OTC SunScripts"
           height="32"/>

      <h2 style="margin-left: 40px;">{{ pageTitle() }}</h2>
    </div>

    <!-- User area -->
    <div class="user-area" *ngIf="user$ | async as user; else signedOut">
      <div class="user-text">
        <div class="user-name">{{ user.displayName || user.email }}</div>
        <div class="user-email" *ngIf="user.email">{{ user.email }}</div>
      </div>

      <kendo-avatar [imageSrc]="user.photoUrl || 'assets/user.png'"
                    shape="circle"
                    [attr.title]="user.displayName || user.email">
      </kendo-avatar>

      <!--<button class="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary" type="button" (click)="logout()">
        Sign out
      </button>-->
    </div>

    <ng-template #signedOut>
      <button class="k-button k-button-md k-rounded-md k-button-solid"
              type="button"
              (click)="login()">
        Sign in
      </button>
    </ng-template>

  </div>
</div>

